import type { ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeExternalLinks from 'rehype-external-links';
import remarkGfm from 'remark-gfm';
export const formatMessageContent = (content: string | undefined): ReactNode => {
  if (!content) return '';
  try {
    return (
      <div className="prose prose-sm dark:prose-invert max-w-none prose-h1:text-lg prose-h2:text-base prose-h3:text-sm prose-h4:text-sm prose-h5:text-sm prose-h6:text-sm prose-ul:mt-0 prose-ol:mt-0 prose-li:my-0">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[[rehypeExternalLinks, { target: '_blank', rel: ['noreferrer', 'noopener'] }]]}
        >
          {content}
        </ReactMarkdown>
      </div>
    );
  } catch {
    return content;
  }
};
